import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { GetDetail, Post, Update, ImageURL } from '../../web_api/api'
import Swal from 'sweetalert2'
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { FaImages } from "react-icons/fa";
export default function PromoCreate() {
    const location = useLocation()
    const ID = location.pathname.split('/')[2]
    const [detailData, setDetailData] = useState([])
    const [image, setImage] = useState([])
    console.log(image, 'img')
    const [title, setTitle] = useState('')
    const [subTitle, setSubTitle] = useState('')
    const [description, setDescription] = useState('')


    const handleImageChange = (e) => {
        if (e.target.files) {
            setImage([...image, e.target.files[0]])

        }
    }
    const update = async () => {
        const formData = new FormData()
        formData.append('title', title)
        formData.append('sub_title', subTitle)
        formData.append('description', description)
        if (image.length !== 0) {
            image.map((item) => (
                formData.append('promotions', item)
            ))
        } else {
            formData.append('promotions', detailData?.image)
        }


        if (detailData?.image === null) {
            Swal.fire({
                title: 'Need Image!',
                text: 'Try again!',
                icon: 'error',
                showConfirmButton: false,
                timer: 2000
            })
        } else {
            await Update('promotion-page/', ID, formData, { headers: { 'Content-Type': 'multipart/form-data' } })

        }

    }

    useEffect(() => {
        const detail = async () => {
            const res = await GetDetail('promotion-page/', ID)
            setDetailData(res.data)
            setTitle(res.data?.title)
            setSubTitle(res.data?.sub_title)
            setDescription(res.data?.description)


        }
        detail()
    }, [])
    return (
        <div>
            <div className='border-1 border-info rounded-1 border p-3 mt-2'>

                <div>
                    <label for='#tn'>Title </label>
                    <input type='text' id='tn' value={title} className='form-control' onChange={(e) => setTitle(e.target.value)} />
                </div>
                <div>
                    <label for='#tn'>Sub Title </label>
                    <input type='text' id='tn' value={subTitle} className='form-control' onChange={(e) => setSubTitle(e.target.value)} />
                </div>
                <div className='row'>
                    <div className='col-8'>
                        <label for='#tn' className={detailData?.image === null ? 'text-red' : ''}>Image </label>
                        <input type='file' id='tn' className='form-control' onChange={handleImageChange} />
                    </div>

                    <div className='col-3 '>
                        {/* To view fullscreen for image */}
                        <PhotoProvider>
                            <PhotoView key={detailData._id} src={ImageURL + detailData.image}>
                                <abbr title='Click View' className={detailData.image ? 'text-blue' : ''}>
                                    <FaImages style={{ width: '50px', height: '100px' }} />
                                </abbr>
                            </PhotoView>
                        </PhotoProvider >

                    </div>
                </div>
                <div>
                    <label for='#tn'>Description </label>
                    <textarea type='text' id='tn' value={description} className='form-control' onChange={(e) => setDescription(e.target.value)} />
                </div>
                {/* <div className='border-2 border-dark w-75 h-25'></div> */}
            </div>

            {/* Footer Button */}
            <div className='mt-3 text-end '>
                <Link to='/promotion' className='btn btn-sm btn-default text-red rounded-2  ' >Cancel</Link>
                <button className='btn btn-sm btn-success rounded-2 ml-2 ' onClick={update}>Update</button>
            </div>
        </div>
    )
}
